export const colors = {
  primary: "#00b4a0",
  secondary: "#5C629E",

  black: "#000000",
  black95: "#050505",
  black80: "#999999",
  black60: "#CCCCCC",
  black40: "#E5E5E5",
  black20: "#F0F0F0",
  black10: "#F7F7F7",

  text01: "#333333",

  white: "#fff",

  error: "#e71d32", //	Error
  success: "#5aa700", //	Success
  warning: "#efc100", //	Warning
  information: "#5aaafa", //	Information

  nav01: "#2E3235", //	Global top bar
  nav02: "#575a5d", //	CTA footer
  nav03: "#323232" //	Global footer
};
